var _path, _mask, _g, _path2, _mask2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.083 22.9997C44.083 11.3557 34.6437 1.91634 22.9997 1.91634C11.3557 1.91634 1.91635 11.3557 1.91635 22.9997C1.91634 34.6437 11.3557 44.083 22.9997 44.083C34.6437 44.083 44.083 34.6437 44.083 22.9997ZM4 23C4 12.5066 12.5066 4 23 4C33.4934 4 42 12.5066 42 23C42 33.4934 33.4934 42 23 42C12.5066 42 4 33.4934 4 23Z",
    fill: "#A7A7A7"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 44,
    height: 44
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.083 22.9997C44.083 11.3557 34.6437 1.91634 22.9997 1.91634C11.3557 1.91634 1.91635 11.3557 1.91635 22.9997C1.91634 34.6437 11.3557 44.083 22.9997 44.083C34.6437 44.083 44.083 34.6437 44.083 22.9997ZM2 23C2 11.402 11.402 2 23 2C34.598 2 44 11.402 44 23C44 34.598 34.598 44 23 44C11.402 44 2 34.598 2 23Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 46,
    width: 46,
    height: 46,
    transform: "rotate(-180 46 46)",
    fill: "#A7A7A7"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5858 23L19.2929 28.2929C18.9024 28.6834 18.9024 29.3166 19.2929 29.7071C19.6834 30.0976 20.3166 30.0976 20.7071 29.7071L26.7071 23.7071C27.0976 23.3166 27.0976 22.6834 26.7071 22.2929L20.7071 16.2929C20.3166 15.9024 19.6834 15.9024 19.2929 16.2929C18.9024 16.6834 18.9024 17.3166 19.2929 17.7071L24.5858 23Z",
    fill: "#A7A7A7"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 16,
    width: 8,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5858 23L19.2929 28.2929C18.9024 28.6834 18.9024 29.3166 19.2929 29.7071C19.6834 30.0976 20.3166 30.0976 20.7071 29.7071L26.7071 23.7071C27.0976 23.3166 27.0976 22.6834 26.7071 22.2929L20.7071 16.2929C20.3166 15.9024 19.6834 15.9024 19.2929 16.2929C18.9024 16.6834 18.9024 17.3166 19.2929 17.7071L24.5858 23Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 35,
    width: 24,
    height: 24,
    transform: "rotate(-180 35 35)",
    fill: "#A7A7A7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.d4aa13b9b50110fae86369f6f056992d.svg";
export { ForwardRef as ReactComponent };